module.exports = __webpack_public_path__ + "static/media/crown.7bfb21cc.svg";